import { getOrDelete } from './glosbe-dictionary-api-helper';
export function getUserMesages(page) {
    const params = { page };
    return getOrDelete({
        endpoint: 'messages', appendToken: true, params,
        options: { credentials: "include" }
    });
}
export function getUserMesageDetails(messageId) {
    const params = { messageId };
    return getOrDelete({
        endpoint: 'message', params, appendToken: true,
        options: { credentials: "include" }
    });
}
